<div class="fragmentation-container">
  <!-- Fragmentation Section -->
  <div class="collapsible-section">
    <button type="button" class="section-header" (click)="toggleFragmentationSection()" [attr.aria-expanded]="!isFragmentationCollapsed">
      <div class="section-title">
        <i class="fas fa-chart-area mr-2"></i>
        <span>{{'GLOBAL.FRAGMENTATION' | translate}}</span>
      </div>
      <i class="fas" [ngClass]="isFragmentationCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
    </button>

    @if (!isFragmentationCollapsed) {
      <div class="section-content">
        <div class="fragmentation-layout">
          <!-- Left side: Chart and controls -->
          <div class="chart-controls-container">
            <!-- Toggle switches (both can be enabled) -->
            <div class="chart-toggle mb-3">
              <label class="toggle-label" (click)="toggleDistribution()">
                <span class="toggle-switch" [class.active]="showDistribution"></span>
                {{'GLOBAL.FRAGMENTATION_DISTRIBUTION' | translate}}
              </label>
              <label class="toggle-label" (click)="toggleCumulative()">
                <span class="toggle-switch" [class.active]="showCumulative"></span>
                {{'GLOBAL.FRAGMENTATION_CUMULATIVE_PERCENTAGE' | translate}}
              </label>
            </div>
            <!-- Chart -->
            <div class="chart-wrapper">
              <div class="y-axis-label">{{'GLOBAL.PERCENTAGE' | translate}}</div>
              <canvas id="fragChart"></canvas>
            </div>
            <!-- Interval Section -->
            <div class="interval-section">
              <h5 class="section-subtitle">{{'GLOBAL.INTERVAL' | translate}}</h5>
              <div class="interval-row">
                <div class="interval-inputs-row">
                  <div class="interval-input-group">
                    <label>{{'GLOBAL.MIN' | translate}}</label>
                    <div class="input-box">
                      <input type="number"
                        min="0"
                        [(ngModel)]="intervalMin"
                        (input)="calculateIntervalPercentage()"
                        class="form-control">
                        <span class="unit">mm</span>
                      </div>
                    </div>
                    <div class="interval-input-group">
                      <label>{{'GLOBAL.MAX' | translate}}</label>
                      <div class="input-box">
                        <input type="number"
                          min="0"
                          [(ngModel)]="intervalMax"
                          (input)="calculateIntervalPercentage()"
                          class="form-control">
                          <span class="unit">mm</span>
                        </div>
                      </div>
                    </div>
                    <div class="interval-percentage">
                      {{intervalPercentage | number:'1.0-2'}} %
                    </div>
                  </div>
                </div>
                <!-- Diameter Size Section -->
                <div class="diameter-section">
                  <h5 class="section-subtitle">{{'GLOBAL.DIAMETER_SIZE' | translate}}</h5>
                  <div class="diameter-row">
                    <div class="diameter-item">
                      <div class="input-box small">
                        <input type="number"
                          min="0" max="100"
                          [(ngModel)]="percentD1"
                          (input)="calculateDiameterFromPercent(1)"
                          class="form-control">
                          <span class="unit">%</span>
                        </div>
                        <span class="diameter-result">{{diameterD1}} mm</span>
                      </div>
                      <div class="diameter-item">
                        <div class="input-box small highlighted">
                          <input type="number"
                            min="0" max="100"
                            [(ngModel)]="percentD2"
                            (input)="calculateDiameterFromPercent(2)"
                            class="form-control">
                            <span class="unit">%</span>
                          </div>
                          <span class="diameter-result">{{diameterD2}} mm</span>
                        </div>
                        <div class="diameter-item">
                          <div class="input-box small">
                            <input type="number"
                              min="0" max="100"
                              [(ngModel)]="percentD3"
                              (input)="calculateDiameterFromPercent(3)"
                              class="form-control">
                              <span class="unit">%</span>
                            </div>
                            <span class="diameter-result">{{diameterD3}} mm</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Right side: Image -->
                    <div class="image-container">
                      @if (imagePath) {
                        <img
                          [src]="imagePath"
                          alt="Muckpile Image"
                          class="fragmentation-image"
                          (click)="openImageModal()" />
                      }
                      @if (!imagePath) {
                        <div class="image-placeholder">
                          <i class="fas fa-image"></i>
                          <span>{{'GLOBAL.NO_IMAGE' | translate}}</span>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
